<div class="panel" [ngClass]="{'opened': opened}">
  <div class="panel-heading" (click)="toggle.emit();">
    <h3>{{title}}</h3>
  </div>
  <div class="panel-body" [@collapse]="opened ? 'closed':'collapsed'">
    <ng-content></ng-content>
  </div>
</div>
